import React from "react";
import CoreH from "./CoreH";

export default function CoreH4(props) {
  return (
    <CoreH {...props} variant="h4" component="h4">
      {props?.children}
    </CoreH>
  );
}
